import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'Blockchain Credentials & NFT Tokens',
    title: 'Verifiable candidate credentials on the blockchain',
    subtitle: 'Issue tamper-proof NFT credential tokens to verified candidates. Any recruiter can instantly verify a candidate\'s screening, assessment, interview, and compliance history with a single link.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #2C3E6B 50%, #5B21B6 100%)',
  },
  sections: [
    {
      label: 'Credential Token System',
      title: 'A complete verified record for every candidate',
      features: [
        { icon: '\ud83d\udd17', title: 'NFT Credential Tokens', desc: 'Each token captures screening score, assessment results, interview ratings, and verification status \u2014 all in one immutable, shareable record.' },
        { icon: '\ud83d\udcca', title: 'Full Score Report', desc: 'Skill breakdowns, AI integrity scores, communication ratings, and compliance clearance \u2014 everything a recruiter needs to make a decision.' },
        { icon: '\u26d3\ufe0f', title: 'On-Chain Verification', desc: 'Every credential is anchored to the CHIRE blockchain with a unique transaction hash, block number, and confirmation count for tamper-proof verification.' },
        { icon: '\ud83c\udf10', title: 'Shareable Link', desc: 'Candidates share a public verification URL. Any recruiter \u2014 even outside CHIRE \u2014 can view and verify the credential instantly. No login required.' },
        { icon: '\ud83d\udee1\ufe0f', title: 'Tamper-Proof', desc: 'Once issued, credential data cannot be altered. The blockchain record ensures integrity and prevents fraudulent claims about skills or qualifications.' },
        { icon: '\ud83c\udfc6', title: 'Readiness Levels', desc: 'Tokens show verified readiness: Fully Verified (4/4 stages), Partially Verified (2-3 stages), or Initial \u2014 giving recruiters instant confidence.' },
      ],
      columns: 3,
    },
    {
      label: 'How It Works',
      title: 'From evaluation to verified credential',
      desc: 'As candidates progress through screening, assessments, interviews, and verification \u2014 their credential token accumulates verified data. Recruiters issue the token when ready.',
      bullets: [
        'Candidate is screened: resume parsed, scored, and ranked',
        'Candidate completes AI assessment: scores and skill breakdown recorded',
        'Candidate does AI video interview: ratings and recommendation stored',
        'Background verification completed: clearance status captured',
        'Recruiter issues NFT credential token with all data',
        'Candidate receives shareable verification link',
        'Any recruiter can verify with one click \u2014 no account needed',
      ],
      visual: '\u26d3\ufe0f',
      visualLabel: 'Credential Issuance Pipeline',
    },
    {
      label: 'For Candidates',
      title: 'Own your verified professional record',
      desc: 'Your CHIRE credential token is yours to keep and share. It proves your skills, assessment scores, and verification status to any employer \u2014 without repeating evaluations.',
      bullets: [
        'View all your credential tokens in the Candidate Portal',
        'Share verification links on LinkedIn, email, or applications',
        'Scores include AI integrity verification \u2014 proving authenticity',
        'Skills breakdown shows exactly what you\'re strong at',
        'Credential persists even if the issuing company changes',
      ],
      visual: '\ud83d\udcf1',
      visualLabel: 'Candidate Credential Wallet',
    },
    {
      label: 'For Recruiters',
      title: 'Verify candidates instantly \u2014 even from other companies',
      desc: 'When a candidate shares their CHIRE credential, you get a complete, verified assessment record. No need to re-screen candidates who have already been evaluated.',
      bullets: [
        'One-click token issuance from the Candidate Detail page',
        'Token aggregates all evaluation data automatically',
        'Public verification page \u2014 no CHIRE account needed to view',
        'Blockchain anchoring prevents credential fraud',
        'Reduce redundant screening for pre-verified candidates',
      ],
      visual: '\u2705',
      visualLabel: 'Instant Verification Dashboard',
    },
  ],
  testimonial: {
    quote: 'The NFT credential system is a game-changer. Candidates share their verified token, and we can see their full assessment history instantly. It cut our re-screening time to zero.',
    name: 'Rachel W.',
    role: 'VP Talent Operations, HireScale',
  },
  cta: {
    title: 'Issue your first credential token today',
    desc: 'Give candidates a verified, shareable record of their skills. Get started with CHIRE.',
  },
};

export default function BlockchainPage() { return <ProductPageTemplate data={DATA} />; }
